import styles from './compartir.module.scss';
const Modal = (props) => {
    const { isOpen, children } = props;
    if (!isOpen) {
        return null;
    }

    return <div className={styles.contentModal}>{children}</div>;
};

export default Modal;
